import { useEffect } from 'react';
import { Client } from '../../prismic1';
import { AdditionalDataProvider } from '../../utils/additional-data-context';
import { useLayout } from '../../utils/layout-context';
import Member from '../../components/member';
import { getLanguage, getExtensionLanguage } from '../../lib/getLanguage';
import Head from '../../components/Head';
import { getPersonsPaths } from '../../services/pagination/personsInfinitePaths';
import errorService from '../../services/error/error-service';

const BoardMember = (props) => {
  const { data, person } = props;
  const { setHeaderColor } = useLayout();

  useEffect(() => {
    setHeaderColor(true);
  }, []);
  return (
    <>
      <Head data={person.data} canonical={`/board-member/${person.uid}`} />
      <AdditionalDataProvider value={props.additionalData}>
        <Member data={person.data}></Member>
      </AdditionalDataProvider>
    </>
  );
};

export async function getStaticProps({
  preview = null,
  previewData = {},
  params,
  locale,
}) {
  const client = Client();
  const languageObject = getLanguage(locale);
  const language = await languageObject.prismicLanguage.toLowerCase();

  const person = await client.getByUID('person', params.uid, {
    lang: language,
  });

  if (!person?.data) {
    return errorService.notFoundResponse;
  }

  return {
    props: {
      person,
    },
  };
}

export async function getStaticPaths() {
  const client = Client();

  const allPerson = await getPersonsPaths();

  const boardMembers = allPerson.filter(
    (person) => person.data.person_type.uid === 'board-member'
  );

  const paths = boardMembers.map((node) => {
    const languageObject = getExtensionLanguage(node.lang);
    const language = languageObject.prismicLanguage.toLowerCase();
    return {
      params: {
        uid: node.uid,
      },
      locale: language,
    };
  });
  return {
    paths,
    fallback: 'blocking',
  };
}

export default BoardMember;
